var DateOccurrenceType = /** @class */ (function () {
    function DateOccurrenceType(id, occurrenceType, occurrenceId, updateDateTime, suggestedDate, approvedDate) {
        this.id = id;
        this.occurrenceType = occurrenceType;
        this.occurrenceId = occurrenceId;
        this.updateDateTime = updateDateTime;
        this.suggestedDate = suggestedDate;
        this.approvedDate = approvedDate;
    }
    return DateOccurrenceType;
}());
export { DateOccurrenceType };
